<div class="cf-dlg" [class.cba-page]="!isDialog">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>credit_card</mat-icon></div>
    <div class="cba-header-text">
      <h2 class="cf-dlg-title">Cuentas bancarias</h2>
      <p class="cf-dlg-subtitle">Cuentas asociadas al contacto</p>
    </div>
    <button *ngIf="isDialog" mat-icon-button class="cf-dlg-close" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando cuentas bancarias…"></app-loading-state>

  <ng-container *ngIf="ready">
    <div class="cf-dlg-body">
      <div class="cba-state cba-state--error" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <p class="cba-state__title">No se pudieron cargar las cuentas bancarias</p>
        <button mat-button class="cf-btn" (click)="load()">
          <mat-icon>refresh</mat-icon> Reintentar
        </button>
      </div>

      <div class="cba-state" *ngIf="!loadError && empty">
        <mat-icon>credit_card_off</mat-icon>
        <p class="cba-state__title">Este contacto no tiene cuentas bancarias</p>
        <p class="cba-state__sub">Pulsa «Nueva cuenta» para añadir la primera.</p>
      </div>

      <div class="cba-list" *ngIf="!loadError && !empty">
        <div class="cba-row" *ngFor="let item of dataSource; trackBy: trackByUid" [class.cba-row--main]="item.remesa">
          <div class="cba-row__icon"><mat-icon>account_balance</mat-icon></div>
          <div class="cba-row__info">
            <div class="cba-row__iban">{{ formatIban(item.iban) }}</div>
            <div class="cba-row__meta">
              <span *ngIf="item.bank">{{ item.bank }}</span>
              <span *ngIf="item.swift">BIC {{ item.swift }}</span>
              <span class="cba-badge" *ngIf="item.remesa"><mat-icon>star</mat-icon> Principal</span>
            </div>
          </div>
          <div class="cba-row__actions">
            <button mat-icon-button class="cba-row__btn" [class.cba-row__btn--star]="item.remesa" [disabled]="!!busyUid"
              (click)="setRemesa(item)"
              [title]="item.remesa ? 'Quitar como principal en domiciliación' : 'Marcar como principal en domiciliación'"
              [attr.aria-label]="item.remesa ? 'Quitar como principal' : 'Marcar como principal'">
              <mat-icon>{{ busyUid === item.uid ? 'hourglass_empty' : (item.remesa ? 'star' : 'star_border') }}</mat-icon>
            </button>
            <button mat-icon-button class="cba-row__btn" [disabled]="!!busyUid" (click)="edit(item)" title="Editar" aria-label="Editar cuenta bancaria">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="cba-row__btn cba-row__btn--danger" [disabled]="!!busyUid" (click)="delete(item)" title="Eliminar" aria-label="Eliminar cuenta bancaria">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer" *ngIf="isDialog || !loadError">
      <button *ngIf="isDialog" mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button *ngIf="!loadError" mat-flat-button class="cf-dlg-btn-primary" (click)="create()">
        <mat-icon>add</mat-icon> Nueva cuenta
      </button>
    </div>
  </ng-container>
</div>
